import * as pdfjsLib from 'pdfjs-dist';

// PDF.js worker setup
// cdnjsではmjsファイルが404になる場合があるため、jsDelivrを使用
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

export default function initMediaPopup() {
    const popup = document.getElementById('media-popup');
    if (!popup) return;

    const container = document.getElementById('media-popup-container');
    const controls = document.getElementById('media-popup-controls');
    const zoomInBtn = document.getElementById('btn-zoom-in');
    const zoomOutBtn = document.getElementById('btn-zoom-out');
    const zoomDisplay = document.getElementById('zoom-level-display');
    const closeBtns = document.querySelectorAll('.js-popup-close');

    let currentPdfDoc = null;
    let currentScale = 1.0;
    let currentMediaType = null; // 'img' or 'pdf'
    let currentImgElement = null;
    const ZOOM_STEP = 0.25;

    // モーダルを閉じる関数
    const closePopup = () => {
        popup.style.display = 'none';
        container.innerHTML = ''; // 中身をクリア
        controls.style.display = 'none'; // ズームUIを隠す
        document.body.style.overflow = ''; // スクロール復元
        currentPdfDoc = null;
        currentMediaType = null;
        currentImgElement = null;
    };

    closeBtns.forEach(btn => {
        btn.addEventListener('click', closePopup);
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.style.display !== 'none') {
            closePopup();
        }
    });

    // 拡大ボタン挿入処理
    const appendEnlargeButton = (target, type, srcOrUrl) => {
        if (!srcOrUrl) return;

        // すでにボタンが挿入されているかチェック
        if (target.nextElementSibling && target.nextElementSibling.classList.contains('js-media-popup-btn')) {
            return;
        }

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'js-media-popup-btn c-media-enlarge-btn';
        
        let iconHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; vertical-align: -3px;"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`;

        if (type === 'img') {
            btn.dataset.src = srcOrUrl;
            btn.innerHTML = iconHtml + '画像を拡大する';
        } else if (type === 'pdf') {
            btn.dataset.pdfUrl = srcOrUrl;
            btn.innerHTML = iconHtml + 'PDFを拡大する';
            btn.style.marginTop = '10px';
        }

        // 要素の直後にボタンを挿入
        target.parentNode.insertBefore(btn, target.nextSibling);
    };

    // WordPressによって追加されるサムネイル情報（width, height, URLサイズ接尾辞）を除去しフルサイズにする処理
    const fixInlineImage = (img) => {
        if (!img) return;
        const src = img.getAttribute('src');
        if (src) {
            const fullSizeSrc = src.replace(/-\d+x\d+(?=\.[a-zA-Z0-9]+(?:[?#]|$))/i, '');
            if (fullSizeSrc !== src) {
                img.setAttribute('src', fullSizeSrc);
            }
        }
        // HTML上のサイズ指定を解除
        img.removeAttribute('width');
        img.removeAttribute('height');
        
        // CSSでレスポンシブにする
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        img.style.display = 'block';
    };

    // 初期読み込み時の対象画像・PDF処理
    const processInitialImages = () => {
        const targetImages = document.querySelectorAll('.p-question-text img, .p-question-images img, .explain-body img, .result-question img');
        targetImages.forEach(img => {
            fixInlineImage(img);
            appendEnlargeButton(img, 'img', img.getAttribute('src'));
        });

        // pdf-viewer.jsがすでにCanvasを展開している可能性があるため、既存のCanvasもチェック
        const targetCanvases = document.querySelectorAll('canvas.js-generated-pdf-canvas');
        targetCanvases.forEach(canvas => appendEnlargeButton(canvas, 'pdf', canvas.dataset.pdfUrl));
    };
    
    processInitialImages();

    // DOMの変更を監視して動的に追加されるPDF Canvasなどにボタンを付与する（pdf-viewer.jsなどによる後追い追加対策）
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    // NodeType 1 is Element
                    if (node.nodeType === 1) {
                        // もし追加されたノード自体が Canvas であれば
                        if (node.tagName && node.tagName.toLowerCase() === 'canvas' && node.classList.contains('js-generated-pdf-canvas')) {
                            appendEnlargeButton(node, 'pdf', node.dataset.pdfUrl);
                        }
                        // もし追加されたノードの子要素に Canvas や画像があるか検索
                        else {
                            const canvases = node.querySelectorAll ? node.querySelectorAll('canvas.js-generated-pdf-canvas') : [];
                            canvases.forEach(canvas => appendEnlargeButton(canvas, 'pdf', canvas.dataset.pdfUrl));
                            
                            // 動的に追加された画像の場合
                            const images = node.querySelectorAll ? node.querySelectorAll('.p-question-text img, .p-question-images img, .explain-body img, .result-question img') : [];
                            images.forEach(img => {
                                fixInlineImage(img);
                                appendEnlargeButton(img, 'img', img.getAttribute('src'));
                            });
                        }
                    }
                });
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // 画面全体へのクリックイベントの委譲（ボタンのクリック監視）
    document.body.addEventListener('click', (e) => {
        const targetBtn = e.target.closest('.js-media-popup-btn');
        if (!targetBtn) return;

        // 対象1: 画像の拡大ボタン
        if (targetBtn.dataset.src) {
            currentMediaType = 'img';
            currentScale = 1.0;
            updateZoomDisplay();

            const img = document.createElement('img');
            // WordPressによって自動付与されるサムネイルのサイズ接尾辞（例：-300x200）を除去してフルサイズを読み込む
            let fullSizeSrc = targetBtn.dataset.src.replace(/-\d+x\d+(?=\.[a-zA-Z0-9]+(?:[?#]|$))/i, '');
            img.src = fullSizeSrc;
            
            // 初回読み込み完了時に本来の大きさを記録しておく（拡大時の基準値）
            img.onload = () => {
                let baseWidth = img.clientWidth || img.naturalWidth;
                if (!baseWidth) baseWidth = Math.min(window.innerWidth * 0.9, 1000);
                img.dataset.baseWidth = baseWidth;
                img.style.width = baseWidth + 'px';
            };
            currentImgElement = img;

            container.innerHTML = '';
            container.appendChild(img);
            
            controls.style.display = 'flex'; // ズームUIを表示（画像でも共通利用）
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden'; // 背景スクロール防止
        }

        // 対象2: PDFの拡大ボタン
        if (targetBtn.dataset.pdfUrl) {
            currentMediaType = 'pdf';
            const pdfUrl = targetBtn.dataset.pdfUrl;
            
            // iframeの代わりにCanvasを生成してPDFを描画
            const canvas = document.createElement('canvas');
            canvas.style.display = 'block';
            canvas.style.margin = '0 auto';
            container.innerHTML = '';
            container.appendChild(canvas);
            
            controls.style.display = 'flex'; // ズームUIを表示
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';

            // Loading表示の追加
            const loader = document.createElement('div');
            loader.className = 'c-media-popup__loader';
            loader.innerHTML = '<span>PDFを読み込み中...</span>';
            container.appendChild(loader);

            // PDF読み込み・描画処理
            // 初回表示フラグ
            let isFirstRender = true;
            currentScale = 1.0;
            updateZoomDisplay();

            const renderPage = (pdf, scale) => {
                pdf.getPage(1).then((page) => {
                    let viewport = page.getViewport({ scale: scale });

                    // 初回表示時のみ、画面幅（90vw）に合わせてベーススケールを決定する
                    if (isFirstRender) {
                        const targetWidth = Math.min(window.innerWidth * 0.9, 1000); // 最大1000px
                        
                        // PDF本来の幅(viewport.width)に対して、目標幅が何倍になるかを計算
                        let calculatedScale = targetWidth / viewport.width;
                        calculatedScale = Math.round(calculatedScale * 100) / 100;
                        calculatedScale = Math.max(0.5, Math.min(calculatedScale, 3.0));

                        currentScale = calculatedScale;
                        // スケールを適用してビューポートを再取得
                        viewport = page.getViewport({ scale: currentScale });
                        updateZoomDisplay();
                        isFirstRender = false;
                    }

                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    
                    // CSSで強制的にサイズを指定することで、レスポンシブな挙動を保証する
                    canvas.style.width = viewport.width + 'px';
                    canvas.style.maxWidth = '100%';
                    canvas.style.height = 'auto';

                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport,
                    };
                    
                    // 描画の完了を待ってからローダーを削除する
                    page.render(renderContext).promise.then(() => {
                        const existingLoader = container.querySelector('.c-media-popup__loader');
                        if (existingLoader) {
                            existingLoader.remove();
                        }
                    });
                });
            };

            let cleanPdfUrl = pdfUrl.split('#')[0].split('?')[0];
            try {
              const urlObj = new URL(cleanPdfUrl, window.location.origin);
              cleanPdfUrl = urlObj.href;
            } catch(e) {}

            pdfjsLib.getDocument(cleanPdfUrl).promise.then((pdf) => {
                currentPdfDoc = pdf;
                renderPage(pdf, currentScale);
            }).catch(err => {
                console.error('PDF Load Error:', err);
                container.innerHTML = `<p style="color:red; font-size:14px; text-align:center; padding: 20px;">PDFの読み込みに失敗しました。<br><br>Debug: ${err.message || err}</p>`;
            });
        }
    });

    // ズームイン・ズームアウト処理
    const updateZoomDisplay = () => {
        if (zoomDisplay) zoomDisplay.textContent = Math.round(currentScale * 100) + '%';
    };

    if (zoomInBtn) {
        zoomInBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            currentScale += ZOOM_STEP;
            updateZoomDisplay();

            if (currentMediaType === 'pdf' && currentPdfDoc) {
                const canvas = container.querySelector('canvas');
                if (canvas) {
                    currentPdfDoc.getPage(1).then((page) => {
                        const viewport = page.getViewport({ scale: currentScale });
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        canvas.style.width = viewport.width + 'px';
                        canvas.style.maxWidth = '100%';
                        page.render({ canvasContext: canvas.getContext('2d'), viewport });
                    });
                }
            } else if (currentMediaType === 'img' && currentImgElement) {
                const baseWidth = currentImgElement.dataset.baseWidth || currentImgElement.clientWidth;
                currentImgElement.style.width = (baseWidth * currentScale) + 'px';
                currentImgElement.style.maxWidth = 'none'; // 枠を超えることを許可
                currentImgElement.style.height = 'auto';
            }
        });
    }

    if (zoomOutBtn) {
        zoomOutBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            currentScale = Math.max(0.25, currentScale - ZOOM_STEP);
            updateZoomDisplay();
            
            if (currentMediaType === 'pdf' && currentPdfDoc) {
                const canvas = container.querySelector('canvas');
                if (canvas) {
                    currentPdfDoc.getPage(1).then((page) => {
                        const viewport = page.getViewport({ scale: currentScale });
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        canvas.style.width = viewport.width + 'px';
                        if (currentScale <= 1.0) canvas.style.maxWidth = '100%';
                        page.render({ canvasContext: canvas.getContext('2d'), viewport });
                    });
                }
            } else if (currentMediaType === 'img' && currentImgElement) {
                const baseWidth = currentImgElement.dataset.baseWidth || currentImgElement.clientWidth;
                currentImgElement.style.width = (baseWidth * currentScale) + 'px';
                if (currentScale <= 1.0) {
                    currentImgElement.style.maxWidth = '100%';
                } else {
                    currentImgElement.style.maxWidth = 'none';
                }
                currentImgElement.style.height = 'auto';
            }
        });
    }
}
